import  { useState } from "react";
import "../../../css/bootstrap5.css";
import "./inputpass.css";
import { ReactComponent as eyeOff } from "../../../assets/icon/eye-off.svg";
import { ReactComponent as Eye } from "../../../assets/icon/eye-fill.svg";
const PasswordInput = (props) => {
  const [focused, setFocused] = useState(false);
  const [type, setType] = useState("password");
  const [Icon, setIcon] = useState(Eye);

  const handleToggle = () => {
    setType(type === "password" ? "text" : "password");
    setIcon(type === "password" ? eyeOff : Eye);
  };

  return (
    <form className="row" onSubmit={(e) => e.preventDefault()}>
      <div className="col">
        <label
          style={{ "--bg": `${bg(props.bgcolor)} ` , "--scolor": `--bs-${props.bcolor}-rgb`}}
          className={`labelpass ${
            focused || props.value ? "floating" : ""
          } text-${props.disabled ? "secondary" : props.bcolor}`}
          aria-label={props.text}
        >
          <input
            className={`inputpass border-${
              props.disabled ? "secondary" : props.bcolor
            } text-${props.textcolor}`}
            type={type}
            placeholder={props.text}
            name="password"
            required
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={(e) => props.onChange(e.target.value)}
            value={props.value}
            disabled={props.disabled}
          />
          <button type="button" className="btnpass" onClick={handleToggle}>
            <Icon />
          </button>
        </label>
      </div>
    </form>
  );
};

const bg = (color) => {
  switch (color) {
    case "dark":
      return "#212529";
      break;
    case "white":
      return "#ffffff";
      break;
  }
};
export default PasswordInput;
